/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { TemplatePortal } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation, } from '@angular/core';
import { mixinDisabled } from '@angular/material/core';
import { Subject } from 'rxjs/Subject';
import { MatTabLabel } from './tab-label';
/**
 * \@docs-private
 */
export class MatTabBase {
}
export const /** @type {?} */ _MatTabMixinBase = mixinDisabled(MatTabBase);
export class MatTab extends _MatTabMixinBase {
    /**
     * @param {?} _viewContainerRef
     */
    constructor(_viewContainerRef) {
        super();
        this._viewContainerRef = _viewContainerRef;
        /**
         * The plain text label for the tab, used when there is no template label.
         */
        this.textLabel = '';
        /**
         * The portal that will be the hosted content of the tab
         */
        this._contentPortal = null;
        /**
         * Emits whenever the label changes.
         */
        this._labelChange = new Subject();
        /**
         * Emits whenevfer the disable changes
         */
        this._disableChange = new Subject();
        /**
         * The relatively indexed position where 0 represents the center, negative is left, and positive
         * represents the right.
         */
        this.position = null;
        /**
         * The initial relatively index origin of the tab if it was created and selected after there
         * was already a selected tab. Provides context of what position the tab should originate from.
         */
        this.origin = null;
        /**
         * Whether the tab is currently active.
         */
        this.isActive = false;
    }
    /**
     * @return {?}
     */
    get content() { return this._contentPortal; }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('textLabel')) {
            this._labelChange.next();
        }
        if (changes.hasOwnProperty('disabled')) {
            this._disableChange.next();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._disableChange.complete();
        this._labelChange.complete();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._contentPortal = new TemplatePortal(this._content, this._viewContainerRef);
    }
}
MatTab.decorators = [
    { type: Component, args: [{selector: 'mat-tab',
                template: "<ng-template><ng-content></ng-content></ng-template>",
                inputs: ['disabled'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                preserveWhitespaces: false,
                exportAs: 'matTab',
            },] },
];
/**
 * @nocollapse
 */
MatTab.ctorParameters = () => [
    { type: ViewContainerRef, },
];
MatTab.propDecorators = {
    'templateLabel': [{ type: ContentChild, args: [MatTabLabel,] },],
    '_content': [{ type: ViewChild, args: [TemplateRef,] },],
    'textLabel': [{ type: Input, args: ['label',] },],
};
function MatTab_tsickle_Closure_declarations() {
    /** @type {?} */
    MatTab.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatTab.ctorParameters;
    /** @type {?} */
    MatTab.propDecorators;
    /**
     * Content for the tab label given by <ng-template mat-tab-label>.
     * @type {?}
     */
    MatTab.prototype.templateLabel;
    /**
     * Template inside the MatTab view that contains an <ng-content>.
     * @type {?}
     */
    MatTab.prototype._content;
    /**
     * The plain text label for the tab, used when there is no template label.
     * @type {?}
     */
    MatTab.prototype.textLabel;
    /**
     * The portal that will be the hosted content of the tab
     * @type {?}
     */
    MatTab.prototype._contentPortal;
    /**
     * Emits whenever the label changes.
     * @type {?}
     */
    MatTab.prototype._labelChange;
    /**
     * Emits whenevfer the disable changes
     * @type {?}
     */
    MatTab.prototype._disableChange;
    /**
     * The relatively indexed position where 0 represents the center, negative is left, and positive
     * represents the right.
     * @type {?}
     */
    MatTab.prototype.position;
    /**
     * The initial relatively index origin of the tab if it was created and selected after there
     * was already a selected tab. Provides context of what position the tab should originate from.
     * @type {?}
     */
    MatTab.prototype.origin;
    /**
     * Whether the tab is currently active.
     * @type {?}
     */
    MatTab.prototype.isActive;
    /** @type {?} */
    MatTab.prototype._viewContainerRef;
}
//# sourceMappingURL=tab.js.map